import { render, staticRenderFns } from "./ExamCard.vue?vue&type=template&id=6baa575a&scoped=true&"
import script from "./ExamCard.vue?vue&type=script&lang=js&"
export * from "./ExamCard.vue?vue&type=script&lang=js&"
import style0 from "./ExamCard.vue?vue&type=style&index=0&id=6baa575a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baa575a",
  null
  
)

component.options.__file = "ExamCard.vue"
export default component.exports